<template>
    <div style="padding: 8px;">
		<van-nav-bar :title="formTitle" left-text="返回" left-arrow @click-left="onClickLeft" fixed>
		</van-nav-bar>
        <grid class="form-box" v-model="data" :descriptions="descriptions.filter(d => !d.hidden)"/>
        <div v-for="detail in details" :key="detail.title" style="position: relative">
            <template v-if="shouldHideDetailName(detail)">
                <h4 class="titleDetailArea">{{detail.title}}</h4>
                <van-button class="btnDetailAreaOperation" type="info" v-if="!detail.isShow" size="mini" icon="arrow-down"
                            @click="toDown(detail)">
                    展开
                </van-button>
                <van-button class="btnDetailAreaOperation" type="info" v-if="detail.isShow" size="mini" @click="toUp(detail)"
                            icon="arrow-up">
                    隐藏
                </van-button>
            </template>
            <template v-if="detail.isShow">
                <div v-for="(detailData, index) in detail.data" :key="detailData.uuid" style="position: relative">
                    <h5 v-if="shouldHideDetailIndex(detailData)">明细{{index+1}}</h5>
                    <van-button v-if="shouldHideDetailDel(detailData) && shouldHideDetailIndex(detailData)" icon="cross" type="danger"
                              size="mini" @click="deleteDetail(detail.tableName,detail.data, index)" class="btnDetailAreaOperation">
                        删除
                    </van-button>
                    <grid v-model="detailData.data" :descriptions="detailData.descriptions.filter(d => !d.hidden)"
                          :index="index + 1"/>
                </div>
                <van-button v-if="shouldHideDetailAdd(detail.data)" size="large" @click="addDetail(detail.tableName,detail.data,detail.descriptions)"
                            type="info" icon="plus">
                    添加行
                </van-button>
            </template>
        </div>
        <div style="vertical-align: middle;position: relative;margin:15px 10px 0;">
            <div style="position:relative;display:block;margin-right: 5px;margin-bottom:5px;"
                 v-for="(item,i) in fileList" :key="i">
                <img src="../assets/file.png" style="width:20px;vertical-align: middle;" alt="" />
                <span style="font-size:14px;" @click="onAttachmentClick(item)">{{item.filename}}</span>
                <van-icon v-if="attrEdit" style="vertical-align: middle;margin-left:5px;" name="cross"
                          @click="delImg(i)"/>
            </div>
            <div v-if="attrEdit" style="display:block;margin-top:15px;">
                <van-uploader :after-read="afterRead" :preview-image="false" multiple
                              preview-size="60px"/>
            </div>
        </div>
        <van-cell-group class="opinionBox">
			<van-field v-show="isAuditable" v-model="opinion" left-icon="edit" right-icon="arrow-down" placeholder="请填写审批意见" autocomplete="off" @click-right-icon="showCommonLanguagePopup" />
        </van-cell-group>
        <table style="width: 100%" class="table-button-group">
            <tr>
                <td v-if="isEditable">
                    <van-button type="info" @click="saveForm" size="large">保存</van-button>
                </td>
                <td v-if="isSubmittable">
                    <van-button type="primary" @click="submitForm" size="large">提交</van-button>
                </td>
                <td v-if='isAuditable'>
                    <van-button type="primary" @click="auditForm(1)" size="large">同意</van-button>
                </td>
                <td v-if='isAuditable'>
                    <van-button type="danger" @click="auditForm(2)" size="large">驳回</van-button>
                </td>
                <td v-if='isAuditable'>
                    <van-button type="info" @click="copyTo()" size="large">抄送</van-button>
                </td>
                <td v-if='isAuditable'>
                    <van-button type="primary" @click="transferTo()" size="large">转办</van-button>
                </td>
            </tr>
        </table>
        <van-popup v-model="showChoice" position="bottom" :style="{ height: '40%' }"
                   :close-on-click-overlay="isClickClose">
            <van-nav-bar :title="title" left-text="取消" right-text="确认" @click-left="onCancel" @click-right="onConfirm"/>
            <van-cell-group v-if="type === 4">
                <van-cell v-if='!isEditable' clickable title="是否返回转办人" @click="isReturn = !isReturn">
                    <van-checkbox v-model="isReturn"  slot="right-icon" />
                </van-cell>
                <van-cell v-if='isEditable' clickable title="是否返回转办人">
                    <van-checkbox v-model="isReturn" disabled slot="right-icon" />
                </van-cell>
            </van-cell-group>
            <van-search placeholder="请输入搜索关键词" v-model="keywords" @search="onSearch"/>
            <van-list @load="onLoad" :finished="finished" id="list" :loading="loading" finished-text="没有更多了">
                <van-checkbox-group v-model="result">
                    <van-cell-group>
                        <van-cell v-for="(item, index) in columns" clickable :key="item.value" :title="item.text"
                                  @click="toggle(index)">
                            <van-checkbox :name="item.value" ref="checkboxes" slot="right-icon"/>
                        </van-cell>
                    </van-cell-group>
                </van-checkbox-group>
            </van-list>
        </van-popup>
        <van-popup v-model="showChoiceNodes" closeable position="bottom" :style="{ height: '40%' }"
                   :close-on-click-overlay="clickCloseChoiceNodes">
            <van-nav-bar title="请选择退回节点"/>
            <van-list @load="onLoadNodes" :finished="finished" id="nodeList" finished-text="">
                <van-cell v-for="item in backNodes" :key="item.value" :title="item.text" @click="backWorkflow(item.value)"></van-cell>
            </van-list>
        </van-popup>
        <van-popup v-model="showCommonLanguage" position="bottom" :style="{ height: '40%'}">
			<van-nav-bar title="请选择常用语" left-text="取消" right-text="确认" @click-left="onCancelCommonLanguage" @click-right="onConfirmCommonLanguage"/>
			<van-radio-group v-model="checkedCommonLanguage" style="padding:0 10px;">
				<div class="radioBox" style="padding:10px 0;" v-for="(common,index) in commonLanguageList" :key="index">
					<van-radio :name="index">{{common}}</van-radio>
					<van-icon style="vertical-align: middle;margin-left:5px;" name="cross" @click="delItem(index)"/>
				</div>
			</van-radio-group>
			<p style="color:#a2a2a2;font-size:18px;margin:10px;">保存常用审批语</p>
			<div class="addLanguageBox" style="padding:0 10px 10px;">
				<van-cell-group style="flex:1;margin-right:10px;"><van-field v-model="addCommonLanguage" style="border: 1px solid #ebedf0;" placeholder="" /></van-cell-group>
				<van-button type="info" @click="saveCommonLanguage">保 存</van-button>
			</div>
		</van-popup>
<!--        <van-dialog v-model="showOfficePreview" :show-confirm-button="false" style="width: 100%; height: 100%;">-->
<!--            <iframe :src="currentOfficePreviewUrl" style="width: 100%; height: 100%;" />-->
<!--        </van-dialog>-->
        <van-popup v-model="showOfficePreview" position="bottom" :style="{ height: '100%' }" title="查看">
            <van-nav-bar :title="currentOfficePreviewTitle" left-text="返回" left-arrow @click-left="showOfficePreview = false"/>
            <iframe :src="currentOfficePreviewUrl" style="width: 100%; height: 100%;border:none;" />
        </van-popup>
		<div v-if="showProcess" style="margin-top:20px">
            <h4 style="display: inline;margin:10px 10px;">审批记录</h4>
            <van-steps direction="vertical" :active="activeStep" active-icon="more">
                <van-step v-for="node in nodes" :key="node.uuid">
                    <h3>{{node.title}}</h3>
                    <div v-for="auditor in node.auditors" :key="auditor.uuid">
                        <p>{{auditor.name}}</p>
                        <p>
                            <span v-if="auditor.result!=='否决'">{{auditor.result}}</span>
                            <span v-if="auditor.result==='否决'"
                                  style="color: red;font-weight: bold;">{{auditor.result}}</span>
                            <span style="margin-left: 5px;" v-html="auditor.opinion"/>&nbsp;&nbsp;&nbsp;<span>{{auditor.operationTime}}</span>
                        </p>
                    </div>
                </van-step>
            </van-steps>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    import formService from '../service/formService';
    import dictionaryService from "../service/dictionaryService";
    import configService from "../service/configService";
    import userInfo from "../store/userInfo";
    import moment from "moment";
    import {API_URL} from "../common/config";
    import {getKeyByUrl} from "../utils/url";
    import Grid from "./Grid";
    import {
        Button, Toast, Icon, Step, Steps, List, Cell, Uploader, Popup, NavBar, Search, Checkbox, CheckboxGroup,
        CellGroup, RadioGroup, Radio, Image, Field, ImagePreview
    } from "vant";
    import attachmentService from "../service/attachmentService";
	import {gridScript} from "../mixin/gridScript";


    const _ = require('lodash');

    export default {
		mixins: [gridScript],
        data: function () {
            return {
				formTitle:'',
				checkedCommonLanguage: '', //默认选中的常用语
				commonLanguageList: [], //常用语数据
				addCommonLanguage:'',
                descriptions: [], // 主区域字段信息
                data: {}, // 主区域对应数据
                /**
                 * 明细区域字段和数据
                 * [
                 *   // 明细区域1
                 *   [
                 *     {
                 *         data: {},
                 *         description: [] // 与 descriptions 结构相同
                 *     }
                 *   ],
                 *   // 明细区域2
                 *   []
                 * ]
                 */
                details: [],
                form: {}, // 流程实例相关信息
                id: this.$route.params.id,
                name: "", // 表单中文名
                workflowId: "", // 工作流 ID，等于 form.workflowId，可以移除
                version: "", // 表单的版本，等于 form.version，可以移除
                auditorIds: "", // 本步骤指定下个步骤审核人时，选定的审核人 ID
                isSubmittable: false,
                isEditable: false,
                attrEdit: false,
                isAuditable: false,
                emptyNames: [], // 未填写的必填项的 label text
                emptyOptionNames: [], // 未选择的字典类型的必填项的 label text
                isClickClose: false, // 本步骤指定下个步骤审核人时，是否隐藏人员选择面板的关闭按钮
                opinion: "",
                steppedRejection: false, // 驳回时，选择节点退回
                showChoiceNodes: false, // 显示选择退回节点面板
                clickCloseChoiceNodes: false, // 显示选择退回节点面板
                showProcess: false,
                showChoice: false, // 本步骤指定下个步骤审核人时，是否显示人员选择面板
				showCommonLanguage: false, //显示常用语面板
                activeStep: 0, // 流程图当前流程节点编号
                nodes: [], // 流程节点
                // todo: 人员多选提取出去
                filter: "", // 本步骤指定下个步骤审核人时，面板的搜索条件（UUID）
                columns: [], // 本步骤指定下个步骤审核人时，面板的可选项
                result: [], // 本步骤指定下个步骤审核人时，面板的选择结果（ID）
                multiple: true, // 选择面板是否多选
                backNodes: [], // 本步骤指定下个步骤审核人时，面板的选择结果（ID）
                text: null, // 本步骤指定下个步骤审核人时，面板的选择结果（名称）
                keywords: '', // 本步骤指定下个步骤审核人时，面板的搜索条件（模糊匹配关键字）
                pageIndex: 0, // 本步骤指定下个步骤审核人时，面板的可选项页码
                pageSize: 5, // 本步骤指定下个步骤审核人时，面板的可选项每页显示条数
                finished: false, // 本步骤指定下个步骤审核人时，面板是否加载完毕
                loading: false, // 本步骤指定下个步骤审核人时，面板是否处于加载中
                type: 0, // 审批类型：1同意；2驳回; 3抄送; 4转办
                fileList: [], // 附件
                title: "请选择下一步骤审核人", // 本步骤指定下个步骤审核人时，面板的标题
                copyIds: "" ,// 抄送人员列表
                showBeforeNodes: false,//是否显示选择退回节点弹层
                isClickCloseNodes: false,
                beforeNodes: [],//之前的审批节点
                backNodeId:"",//选择退回的节点
                isReturn:true,
                showOfficePreview: false,
                currentOfficePreviewUrl: null,
                currentOfficePreviewTitle: null
            }
        },
        created: async function () {
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = this.scriptUrl;
            document.getElementsByTagName('head')[0].appendChild(script);

            window.add = this.add;
            window.hide = this.hide;
            window.show = this.show;
            window.message = this.message;
            window.getValue = this.getValue;
            window.asyncRpc = this.asyncRpc;
            window.setValue = this.setValue;
            window.setStyle = this.setStyle;
            window.hideDetail = this.hideDetail;
            window.showDetail = this.showDetail;
            window.getFormData = this.getFormData;
            window.showRelevance = this.showRelevance;
            window.setRequired = this.setRequired;
            window.setReadonly = this.setReadonly;
            window.asyncRequest = this.asyncRequest;
            window.showTextCell = this.showTextCell;
            window.hideTextCell = this.hideTextCell;
            window.setStyleDetail = this.setStyleDetail;
            window.getValueDetail = this.getValueDetail;
            window.setValueDetail = this.setValueDetail;
            window.hideDetailArea = this.hideDetailArea;
            window.showDetailArea = this.showDetailArea;
            window.hideDetailHeader = this.hideDetailHeader;
            window.showDetailHeader = this.showDetailHeader;
            window.setRequiredDetail = this.setRequiredDetail;
            window.setReadonlyDetail = this.setReadonlyDetail;
            window.getValueOfAllRowsDetail = this.getValueOfAllRowsDetail;
            window.setDictionary = this.setDictionary;
            window.setDictionaryDetail = this.setDictionaryDetail;
            let dataResp = await formService.getFormData(this.$route.params.workflowTemplateId, this.$route.params.id);
            if (dataResp.data.Status === "1") {
                this.descriptions = dataResp.data.Data.description;
                this.form = dataResp.data.Data.form;
                this.data = dataResp.data.Data.data;
				if(this.$route.params.defaultValue) {
					let defaultValue = JSON.parse(this.$route.params.defaultValue);
					this.data = Object.assign(this.data,defaultValue);
				}
                this.name = this.form.formName;
                this.workflowId = this.form.workflowId;
                this.showProcess = this.form.showProcess;
				this.activeStep = this.form.activeStep;
                this.nodes = this.form.nodes;
                this.isEditable = this.form.editable;
                this.attrEdit = this.form.attrEdit;
                this.isAuditable = this.form.auditable;
                this.isSubmittable = this.form.submittable;
                this.version = this.form.version;
                this.fileList = this.form.attachments;
                this.fileList.map(item => Object.assign(item, {url: API_URL + item.url}));
                this.details = dataResp.data.Data.details;
                if (!this.data.attachmentIds) {
                    this.data.attachmentIds = "";
                }
                userInfo.commit('setNavTitle', this.name);
                //formService.insertReadRecord(this.workflowId);
				
            }
            if (typeof onload !== "undefined" && onload instanceof Function){
                onload();
            }
        },
        watch: {
            keywords() {
                this.pageIndex = 0;
                this.columns = [];
                this.onLoad();
            }
        },
        mounted: async function() {
			if(this.$route.params.defaultValue) {
				let defaultValue = JSON.parse(this.$route.params.defaultValue);
				this.formTitle = defaultValue.formName;
			}
            let resp = await configService.getConfigByName("驳回时自由选择节点");
            if (resp.data.Status === "1"){
                if (resp.data.Data && resp.data.Data.value === "是"){
                    this.steppedRejection = true;
                }
            }
        },
        components: {
            Grid,
            [Button.name]: Button,
            [Icon.name]: Icon,
            [Steps.name]: Steps,
            [Step.name]: Step,
            [List.name]: List,
            [Search.name]: Search,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
            [Radio.name]: Radio,
            [RadioGroup.name]: RadioGroup,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [NavBar.name]: NavBar,
            [Popup.name]: Popup,
            [Uploader.name]: Uploader,
            [Image.name]: Image,
            [Field.name]: Field
        },
        computed: {
            scriptUrl: function () {
                return API_URL+"/wf/form/vsheet/script?workflowTemplateId="+this.$route.params.workflowTemplateId;
            }
        },
        store: userInfo,
        methods: {
            getEmptyNames(){
                let lastData = this.data;
                for (let key in lastData) {
                    const value = lastData[key];
                    const des = this.descriptions.find(item => item.fieldName === key);
                    if (des != undefined) {
                        if (!des.hidden && des.required && !des.readOnly && (value == undefined || value.length == 0 ||((des.inputType==6 || des.inputType==8) && value=="0"))) {
                            if(des.inputType==6 || des.inputType==8){
                                this.emptyOptionNames.push(des.fieldShowName);
                            }else{
                                this.emptyNames.push(des.fieldShowName);
                            }
                        }
                    }
                }
                this.details.forEach(item => {
                    const title = item.title;
                    if(item.data.length>0){
                        const detailData = item.data[0].data;
                        const detailDescriptions = item.data[0].descriptions;
                        for (let dKey in detailData) {
                            const detailValue = detailData[dKey];
                            const detailDes = detailDescriptions.find(item => item.fieldName === dKey);
                            if (detailDes != undefined) {
                                if (!detailDes.hidden && detailDes.required && !detailDes.readOnly && (detailValue == undefined || detailValue.length == 0 || ((detailDes.inputType==6 || detailDes.inputType==8) && detailValue == "0"))) {
                                    if(detailDes.inputType==6 || detailDes.inputType==8){
                                        this.emptyOptionNames.push(title + "第一行" + detailDes.fieldShowName);
                                    }else{
                                        this.emptyNames.push(title + "第一行" + detailDes.fieldShowName);
                                    }
                                }
                            }
                        }
                    }
                });
            },
            async saveForm() {
                Toast.loading({
                    duration:0,
                    message: '保存中...',
                    forbidClick: true
                });
                this.getEmptyNames();
                if (this.emptyNames.length > 0 || this.emptyOptionNames.length > 0) {
                    var message="";
                    if(this.emptyNames.length > 0){
                        const empty = this.emptyNames.join(",");
                        message += empty;
                        message += "未填写！"
                    }
                    if(this.emptyOptionNames.length > 0){
                        const emptyOptions = this.emptyOptionNames.join(",");
                        message += emptyOptions;
                        message += "未选择！"
                    }
                    Toast.clear();
                    Toast({
                        message: message
                    });
                    this.emptyNames = [];
                    this.emptyOptionNames = [];
                    return;
                }
				if(this.$route.params.defaultValue) {
					let defaultValue = JSON.parse(this.$route.params.defaultValue);
					this.data = Object.assign(defaultValue,this.data);
				}
                let resp = await formService.saveForm(this.data, this.details, this.$route.params.workflowTemplateId);
                if (resp.data.Status === "1") {
                    this.id = resp.data.Data;
                    this.data.uuid = resp.data.Data;
					this.isSubmittable = true;
					Toast.clear();
                    Toast.success('保存成功！');
                } else {
                    Toast.clear();
                    Toast.fail(resp.data.Message);
                }
            },
            async submitForm() {
                Toast.loading({
                    duration:0,
                    message: '提交中...',
                    forbidClick: true
                });
				this.pageIndex = 0;
                this.type = 0;
                this.multiple = true;
                this.title = "请选择下一步骤审核人";
                this.isClickClose = false;
                this.getEmptyNames();
                if (this.emptyNames.length > 0 || this.emptyOptionNames.length > 0) {
                    var message="";
                    if(this.emptyNames.length > 0){
                        const empty = this.emptyNames.join(",");
                        message += empty;
                        message += "未填写！"
                    }
                    if(this.emptyOptionNames.length > 0){
                        const emptyOptions = this.emptyOptionNames.join(",");
                        message += emptyOptions;
                        message += "未选择！"
                    }

                    Toast.clear();
                    Toast({
                        message: message
                    });
                    this.emptyNames = [];
                    this.emptyOptionNames = [];
                    return;
                }
                let res = await formService.saveForm(this.data, this.details, this.$route.params.workflowTemplateId);
                if (res.data.Status === "1") {
                    let resp = await formService.submitForm(this.id, this.name, this.version, this.auditorIds);
                    if (resp.data.Status === "1") {
                        this.auditorIds = "";
                        this.result = [];
                        this.columns = [];
                        Toast.clear();
                        if (resp.data.Data && resp.data.Data.length > 0) {
                            const idArray = resp.data.Data.map(user => {
                                return user.uuid;
                            });
                            this.filter = 'uuid in (' + idArray.map(value => '\'' + value + '\'').join(',') + ')';
                            this.showChoice = true;
                            this.onLoad();
                        } else if (resp.data.Data && resp.data.Data.length === 0) {
                            this.filter = "";
                            this.showChoice = true;
                            this.onLoad();
                        } else {
                            this.showChoice = false;
                            this.filter = "";
                            Toast.success('提交成功！');
                            this.$router.go(-1);
                        }
                    } else {
                        this.auditorIds = "";
                        Toast.clear();
                        Toast.fail(resp.data.Data);
                    }
                } else {
                    Toast.clear();
                    Toast.fail(res.data.Message);
                }
            },
            async auditForm(type) {
                this.type = type;
                this.multiple = true;
                if(this.opinion===undefined || this.opinion===""){
                    Toast.fail("请填写审批意见！");
                    return;
                }
                if (this.type === 2 && this.steppedRejection) {
                    this.showChoiceNodes = true;
                    this.clickCloseChoiceNodes = true;
                } else {
                    this.title = "请选择下一步骤审核人";
                    this.isClickClose = false;
                    
                    let res={data:{Status:"1"}};
                    if(this.isEditable){
                        this.getEmptyNames();
                        if (this.emptyNames.length > 0 || this.emptyOptionNames.length > 0) {
                            var message="";
                            if(this.emptyNames.length > 0){
                                const empty = this.emptyNames.join(",");
                                message += empty;
                                message += "未填写！"
                            }
                            if(this.emptyOptionNames.length > 0){
                                const emptyOptions = this.emptyOptionNames.join(",");
                                message += emptyOptions;
                                message += "未选择！"
                            }

                            Toast({
                                message: message
                            });
                            this.emptyNames = [];
                            this.emptyOptionNames = [];
                            return;
                        }
                        res = await formService.saveForm(this.data, this.details, this.$route.params.workflowTemplateId);
                    }
                    if (res.data.Status === "1") {
                        let resp = await formService.auditForm(this.workflowId, type, this.opinion, this.version, this.auditorIds);
                        if (resp.data.Status === "1") {
                            this.auditorIds = "";
                            Toast.success('操作成功！');
                            if(typeof uexWindow !== "undefined"){
                                // eslint-disable-next-line no-undef
                                uexWindow.evaluateScript("",'0', " goBackAndReloadList ()");
                            } else {
                                this.$router.go(0);
                            }
                        } else if (resp.data.Status === "6") {
                            this.auditorIds = "";
                            this.result = [];
                            this.columns = [];
                            if (resp.data.Data) {
                                const users = JSON.parse(resp.data.Data);
                                const idArray = users.map(user => {
                                    return user.uuid;
                                });
                                this.filter = 'uuid in (' + idArray.map(value => '\'' + value + '\'').join(',') + ')';
                                this.showChoice = true;
                                this.onLoad();
                            } else {
                                this.filter = "";
                                this.showChoice = true;
                                this.onLoad();
                            }
                        } else {
                            this.auditorIds = "";
                            Toast.fail(resp.data.Data);
                        }
                    } else {
                        Toast.fail(res.data.Message);
                    }
                }
            },
            onConfirm() {
				if(this.result.length < 1) {
					Toast.fail("请选择下一步骤审核人！");
					return;
				}
                if (this.type === 1 || this.type === 2) {
                    this.showChoice = false;
                    this.isEditable = false;
                    this.isAuditable = false;
                    this.isSubmittable = false;
                    this.auditorIds = this.result.join(",");
                    this.auditForm(this.type);
                } else if (this.type === 0) {
                    this.showChoice = false;
                    this.isEditable = false;
                    this.isAuditable = false;
                    this.isSubmittable = false;
                    this.auditorIds = this.result.join(",");
                    this.submitForm();
                } else if(this.type === 4){
                    if(this.result.length===0){
                        Toast.fail("请选择转办人！");
                        return;
                    }
                    this.transferToOthers(this.result[0]);
                } else{
                    if (this.copyIds.length > 0) {
                        this.copyIds += ",";
                    }
                    this.copyIds += this.result.join(",");
                    this.sendCopy(this.result.join(","));
                    this.result = [];
                }
            },
            onCancel(){
				this.keywords='';
				this.showChoice = false;
//                 if(this.type===3 || this.type===4){
//                     this.keywords='';
//                     this.showChoice = false;
//                 }else{
//                     Toast.fail("请选择下一步骤审核人！");
//                     return;
//                 }
            },
            async onLoad() {
                this.loading = true;
                this.pageIndex++;
                let resp = await dictionaryService.getOptions("base_staff", this.pageIndex, this.pageSize, this.filter,
                    this.keywords);
                this.loading = false;
                if (resp.data.Status === "1") {
                    this.finished = resp.data.Data.length < this.pageSize;
                    resp.data.Data.forEach(acb => {
                        this.columns.push({text: acb.name, value: acb.uuid});
                    });
                }
            },
            onSearch(){
                this.pageIndex = 0;
                this.columns = [];
                this.onLoad();
            },
            async onLoadNodes() {
                let resp = await formService.getBeforeNodeList(this.data.workflowTemplateId,this.id,this.form.currentNodeId);
                if (resp.data.Status === "1") {
                    this.finished = true;
                    resp.data.Data.forEach(acb => {
                        this.backNodes.push({text: acb.title, value: acb.uuid});
                    });
                }
            },
            async backWorkflow(nodeId){
                this.showChoiceNodes = false;
                let resp = await formService.backWorkflow("驳回", this.form.workflowId, nodeId, this.opinion, this.form.currentNodeId);
                if (resp.data.Status === "1"){
                    Toast.success(resp.data.Data);
                    if(typeof uexWindow !== "undefined"){
                        uexWindow.evaluateScript("",'0', " goBackAndReloadList ()");
                    } else {
                        this.$router.go(0);
                    }
                } else {
                    Toast.fail(resp.data.Data);
                }
            },
            copyTo() {
                this.type = 3;
                this.multiple = true;
                this.title = "请选择抄送人";
                this.isClickClose = true;
                this.result = [];
                this.columns = [];
                if (this.copyIds.length > 0) {
                    this.filter = 'uuid not in (' + this.copyIds.split(",").map(value => '\'' + value + '\'').join(',') + ')';
                }
                this.showChoice = true;
                this.pageIndex = 0;
                this.onLoad();
            },
            transferTo() {
                this.type = 4;
                this.multiple = false;
                this.title = "请选择转办人";
                this.isClickClose = true;
                this.result = [];
                this.columns = [];
                this.filter = "uuid not in ('"+ userInfo.state.userId +"')";
                this.showChoice = true;
                this.pageIndex = 0;
                this.onLoad();
            },
            async transferToOthers(staffId){
                if(staffId===undefined || staffId===""){
                    return;
                }
                let res = await formService.transferToOthers(staffId, this.form.currentNodeId, this.workflowId,this.isReturn);
                if (res.data.Status === "1") {
                    this.showChoice = false;
                    Toast.success("转办成功！");
                    if(typeof uexWindow !== "undefined"){
                        uexWindow.evaluateScript("",'0', " goBackAndReloadList ()");
                    } else {
                        this.$router.go(0);
                    }
                }
            },
            async sendCopy(ids) {
                if(ids===undefined || ids===""){
                    return;
                }
                let res = await formService.saveCopy(this.id, ids);
                if (res.data.Status === "1") {
                    let resp = await formService.sendEmails(this.form.creatorName, ids, this.form.serialNumber, this.form.displayName);
                    this.showChoice = false;
                    Toast.success("抄送成功！");
                }
            },
            addDetail(detailName,detail, descriptions) {
                detail.push({"data": {}, "descriptions": descriptions});
                if(typeof afterAddRow != 'undefined' && afterAddRow instanceof Function) {
                    afterAddRow(detailName,detail.length);
                }
            },
            deleteDetail(detailName,detail, index) {
                let callback = function () {
                    for (var i = 0; i < detail[index].descriptions.length; i++) {
                        var desc = detail[index].descriptions[i];
                        if (desc.inputType === 6) {
                            setValueDetail(desc.fieldName, '0', index + 1, detailName);
                        } else {
                            setValueDetail(desc.fieldName, null, index + 1, detailName);
                        }
                    }
                    detail.splice(index, 1);
                };
                if (typeof beforeDeleteRow !== "undefined" && beforeDeleteRow instanceof Function) {
                    beforeDeleteRow(detailName,index+1,callback);
                } else {
                    callback()
                }
            },
            toDown(detail) {
                detail.isShow = true;
            },
            toUp(detail) {
                detail.isShow = false;
            },
            toggle(index) {
                if(this.multiple){
                    this.$refs.checkboxes[index].toggle();
                }else{
                    this.result=[];
                    this.result.push(this.columns[index].value);
                }
            },
            async afterRead(file) {
                let param = new FormData();
                //通过append向form对象添加数据
                let fileData = new File([file.file], encodeURIComponent(file.file.name));
                param.append("Filedata", fileData);
                //添加请求头
                let config = {
                    headers: {"Content-Type": "multipart/form-data"},
                };
                let res = await formService.uploadFile(param, config);
                if (res.data.Status === "1") {
                    if (this.data.attachmentIds && this.data.attachmentIds.length > 0) {
                        this.data.attachmentIds += ",";
                    } else {
                        this.data.attachmentIds = "";
                    }
                    this.data.attachmentIds += res.data.Data.uuid;
                    this.fileList.push({
                        url: API_URL + "/oa/common/attachment/showThumb?id=" + res.data.Data.uuid,
                        uuid: res.data.Data.uuid,
						filename: res.data.Data.filename
                    });
                    file.index = res.data.Data.uuid;
                }
            },
            async delImg(i) {
                const attachmentId = this.fileList[i].uuid;
                let res = await formService.deleteFile(attachmentId);
                if (res.data.Status === "1") {
                    let attachmentIds = this.data.attachmentIds;
                    if (attachmentIds.indexOf(attachmentId + ",") > -1) {
                        attachmentIds = attachmentIds.replace(attachmentId + ",", "");
                    } else {
                        attachmentIds = attachmentIds.replace(attachmentId, "");
                    }
                    this.fileList.splice(i, 1);
                    this.data.attachmentIds = attachmentIds;
                }
            },
            getValue(prop) {
                let description = this.descriptions.find(item => item.fieldName === prop);
                if (!description) { return null}
                let value = this.data[prop];
                return description.inputType !== 4 ? value : moment(value).format(description.format.toUpperCase());
            },
            setValue(prop, value) {
                this.data[prop] = value;
                let description = this.descriptions.find(desc => desc.fieldName === prop);
                eval(description.onChange);
            },
            getValueDetail(prop, index, detailName) {
                let detailData = this.details.find(detail => detail.tableName === detailName);
                if (detailData !== undefined) {
                    let description = detailData.descriptions.find(item => item.fieldName === prop);
                    if (!description) { return null}
                    let value = detailData.data[index - 1].data[prop];
                    return description.inputType !== 4 ? value : moment(value).format(description.format.toUpperCase());
                }
            },
            setValueDetail(prop, value, index, detailName) {
                let detailData = this.details.find(detail => detail.tableName === detailName);
                if (detailData !== undefined) {
					let detailRow = detailData.data[index - 1];
                    detailRow.data[prop] = value;
					let description = detailData.descriptions.find(item => item.fieldName === prop);
					let rowIndex = index;
					eval(description.onChange);
                    Vue.set(detailData.data, index - 1, detailRow);
                }
            },
            setRequired(props, trueOrFalse) {
                this.descriptions.forEach(item => {
                    if (props.some(prop => prop === item.fieldName)) {
                        item.required = trueOrFalse;
                    }
                })
            },
            setReadonlyDetail(props, trueOrFalse, index, detailName) {
                let detailData = this.details.find(detail => detail.tableName === detailName);
                if (detailData !== undefined) {
                    let detailRow = detailData.data[index - 1];
                    detailRow.descriptions.forEach(item => {
                        if (props.some(prop => prop === item.fieldName)) {
                           item.readOnly = trueOrFalse;
                        }
                    });
                    Vue.set(detailData.data, index - 1, detailRow);
                }
            },
            setRequiredDetail(props, trueOrFalse, index, detailName) {
                let detailData = this.details.find(detail => detail.tableName === detailName);
                if (detailData !== undefined) {
                    let detailRow = detailData.data[index - 1];
                    detailRow.descriptions.forEach(item => {
                        if (props.some(prop => prop === item.fieldName)) {
                            item.required = trueOrFalse;
                        }
                    });
                    Vue.set(detailData.data, index - 1, detailRow);
                }
            },
            hide(props) {
                let index = null;
                let temp = null;
                this.descriptions.forEach((item,i) => {
                    if (props.some(prop => prop === item.fieldName)) {
                        index = i;
                        item.hidden = true;
                        temp = item;
                    }
                });
                Vue.set(this.descriptions, index, temp);
            },
            add(detailName) {
                let detailData = this.details.find(detail => detail.tableName === detailName);
                if (detailData !== undefined) {
                    this.addDetail(detailName,detailData.data, detailData.descriptions);
                }
            },
            show(props) {
                let index = null;
                let temp = null;
                this.descriptions.forEach((item,i) => {
                    if (props.some(prop => prop === item.fieldName)) {
                        index = i;
                        item.hidden = false;
                        temp = item;
                    }
                });
                Vue.set(this.descriptions, index, temp);
            },
            getValueOfAllRowsDetail(prop, detailName) {
                let values = [];
                let detailData = this.details.find(detail => detail.tableName === detailName);
                detailData.data.forEach(item => values.push(item.data[prop]));
                return values;
            },
            hideDetail(props, index, detailName) {
                let detailData = this.details.find(detail => detail.tableName === detailName);
                if (detailData !== undefined) {
                    let detailRow = detailData.data[index - 1];
                    detailRow.descriptions.forEach(item => {
                        if (props.some(prop => prop === item.fieldName)) {
                            item.hidden = true;
                        }
                    });
                    Vue.set(detailData.data, index - 1, detailRow);
                }
            },
            showDetail(props, index, detailName) {
                let detailData = this.details.find(detail => detail.tableName === detailName);
                if (detailData !== undefined) {
                    let detailRow = detailData.data[index - 1];
                    detailRow.descriptions.forEach(item => {
                        if (props.some(prop => prop === item.fieldName)) {
                            item.hidden = false;
                        }
                    });
                    Vue.set(detailData.data, index - 1, detailRow);
                }
            },
            hideDetailArea(detailName) {
                let detailData = this.details.find(detail => detail.tableName === detailName);
                if (detailData !== undefined) {
                    let fields = detailData.descriptions.map(item => item.fieldName);
                    let detailRow = detailData.data;
                    detailRow.forEach((item, index) => this.hideDetail(fields, index + 1, detailName));
                }
            },
            showDetailArea(detailName) {
                let detailData = this.details.find(detail => detail.tableName === detailName);
                if (detailData !== undefined) {
                    let fields = detailData.descriptions.map(item => item.fieldName);
                    let detailRow = detailData.data;
                    detailRow.forEach((item, index) => this.showDetail(fields, index + 1, detailName));
                }
            },
            hideDetailHeader() {
            },
            showDetailHeader() {
            },
            showTextCell() {
            },
            hideTextCell() {
            },
            asyncRpc(method, param, callback) {
                let data = {
                    method: method,
                    workflowTemplateId: this.data.workflowTemplateId,
                    paramsJson: JSON.stringify(param)
                };
                this.asyncRequest('/wf/form/vsheet/rpc', "post", data, callback)
            },
            getFormData() {
                let data = this.data;
                data.workflowStatus = this.form.status;
                this.details.forEach(item => {
                    let detailName = item.tableName;
                    let detailData = [];
                    item.data.forEach(detail => detailData.push(detail.data));
                    data[detailName] = detailData
                });
                return data;
            },
            setDictionaryDetail(field, dictionaryItems, rowIndex, detailName) {
                let detail = this.details.find(d => d.tableName === detailName);
                if (detail !== undefined) {
                    let detailRow = detail.data[rowIndex - 1];
                    detailRow.descriptions.forEach((item,i) => {
                        if (field === item.fieldName) {
                            item.options = dictionaryItems;
                            item.dictionary = null;
                            Vue.set(detailRow.descriptions, i, item);
                        }
                    });
                }
            },
            setDictionary(field, dictionaryItems) {
                this.descriptions.forEach((item,index) => {
                    if (field === item.fieldName) {
                        item.options = dictionaryItems;
                        item.dictionary = null;
                        Vue.set(this.descriptions, index, item);
                    }
                });
            },
            setStyle(props, style) {
                let index = null;
                let temp = null;
                this.descriptions.forEach((item,i) => {
                    if (props.some(prop => prop === item.fieldName)) {
                        index = i;
                        item.style = style;
                        temp = item;
                    }
                });
                Vue.set(this.descriptions,index, temp);
            },
            setStyleDetail(props, style,index,detailName) {
                let detail = this.details.find(d => d.tableName === detailName);
                if (detail !== undefined) {
                    detail.data[index - 1].descriptions.forEach(item => {
                        if (props.some(prop => prop === item.fieldName)) {
                            item.style = style;
                        }
                    });
                }
            },
            shouldHideDetailName(detail) {
                let hide = true;
                detail.data.forEach(item => {
                    hide = this.shouldHideDetailIndex(item);
                });
                return detail.data.length == 0 ? false : hide;
            },
            shouldHideDetailIndex(detailData) {
                let data = detailData.descriptions.filter(desc => !desc.hidden);
                return data.length !== 0;
            },
            shouldHideDetailDel(detailData) {
                let data = detailData.descriptions.filter(desc => !desc.readOnly);
                return data !== undefined && data.length !== 0;
            },
            shouldHideDetailAdd(detail) {
                let shouldHideDetailAdd = true;
                for (let i = 0 ;i < detail.length ; i++){
                    if (!this.shouldHideDetailDel(detail[i])){
                        shouldHideDetailAdd = false;
                    }
                }
                return shouldHideDetailAdd;
            },
            message(msg,type){
                if (type === "success"){
                    Toast.success(msg);
                } else {
                    Toast.fail(msg);
                }
            },
            showRelevance(url,title){
                this.currentOfficePreviewUrl = url;
                this.currentOfficePreviewTitle = title;
                this.showOfficePreview = true;
            },
			showCommonLanguagePopup() {
				if(localStorage.getItem("commonLanguage")) {
                    this.commonLanguageList = localStorage.getItem("commonLanguage").split(',');
                }else {
                    let options = ["同意","请领导批示","无意见"];
					this.commonLanguageList = options;
                    localStorage.setItem("commonLanguage",options);	
                }
				this.showCommonLanguage = true;
			},
			onCancelCommonLanguage() {
				this.showCommonLanguage = false;
			},
			onConfirmCommonLanguage() {
				if(this.checkedCommonLanguage !== '') {
					this.opinion = this.commonLanguageList[this.checkedCommonLanguage];
				}
				this.showCommonLanguage = false;
			},
			delItem(index) {
				this.commonLanguageList.splice(index, 1);
				localStorage.setItem("commonLanguage",this.commonLanguageList);	
			},
			saveCommonLanguage() {
				if(this.addCommonLanguage !== '') {
					this.commonLanguageList.push(this.addCommonLanguage);
					localStorage.setItem("commonLanguage",this.commonLanguageList);	
					this.addCommonLanguage = '';
				}
			},
            async onAttachmentClick(attachment) {
                let arr = attachment.filename.split('.');
                let extension = arr.length > 1 ? arr[arr.length - 1] : '';
                let shareResp = await attachmentService.share(attachment.uuid);
                let resp = await configService.getConfigByName('Office预览链接');
                if (resp.data.Status === "1"){
                    if (resp.data.Data) {
                        if (['xls', 'xlsx', 'doc', 'docx', 'ppt', 'pptx', 'pdf'].indexOf(extension) > -1) {
                            let url = resp.data.Data.value.replace('${uuid}', attachment.uuid);
                            url = url.replace('${shareKey}', shareResp.data.Data);
                            this.currentOfficePreviewUrl = url;
                            this.currentOfficePreviewTitle = attachment.filename;
                            this.showOfficePreview = true;
                        } else if (['jpg', 'png', 'gif', 'jpeg'].indexOf(extension) > -1) {
                            ImagePreview([
                                API_URL + '/crm/link/file/download?key=' + shareResp.data.Data
                            ]);
                        } else {
                            Toast({
                                message: '暂不支持该格式的文件，请前往PC端查看'
                            });
                        }
                    } else {
                        if (['jpg', 'png', 'gif', 'jpeg'].indexOf(extension) > -1) {
                            ImagePreview([
                                API_URL + '/oa/common/attachment/downloadFile?id=' + attachment.uuid
                            ]);
                        } else {
                            Toast({
                                message: '暂不支持该格式的文件，请前往PC端查看'
                            });
                        }
                    }
                }
            },
			onClickLeft() {
			    this.$router.go(-1);
			},
        }
    }
</script>
<style>
    .btnDetailAreaOperation {
        position: absolute;
        top: 0;
        right: 0;
        padding: 0 20px;
    }

    .titleDetailArea {
        color: #1890ff;
    }

    .table-button-group td{
        padding: 0 0.2rem;
    }
	.radioBox {
		display: flex;
		align-items: center;
		border-bottom:1px solid #ebedf0;
		justify-content: space-between;
	}
	.addLanguageBox {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
    .van-button__icon{
        color: white;
        margin-right: 0;
    }
	.opinionBox .van-icon-edit {
		font-size:1.2rem;
	}
    .van-field{
        color: #a2a2a2;
    }
	.form-box{
		margin-top:120px;
	}
</style>